import { useMutation, useQueryClient } from '@tanstack/react-query';
import { putApiV1ScenariosByScenarioIdDetails } from '../api/generated';
import { useErrorStore } from '../stores/ErrorStore';
import { queryKeys } from './queryKeys';

type UpdateScenarioDetailsParams = {
  scenarioId: string;
  name?: string;
  description?: string;
};

export const useUpdateScenarioDetails = () => {
  const queryClient = useQueryClient();
  const { addError } = useErrorStore();

  return useMutation({
    mutationFn: ({
      scenarioId,
      name,
      description,
    }: UpdateScenarioDetailsParams) =>
      putApiV1ScenariosByScenarioIdDetails({
        path: { scenarioId },
        body: { name, description },
      }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.scenario(variables.scenarioId),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.scenarios() });
    },
    onError: () => {
      addError('Failed to update scenario details. Please try again.');
    },
  });
};
